module.exports = __webpack_public_path__ + "static/linkedin-d3568773d9857bd5ec08feadd15cb2bc.svg";